const clientStatusLogs = [
  {
    status: 1,
    text: 'Tu orden ha sido aceptada! Espera a que el proveedor nos de una fecha de entrega.'
  },
  {
    status: 2,
    text: 'Tu orden se encuentra en camino!'
  },
  {
    status: 3,
    text: 'Tu orden ha sido entregada. Gracias por comprar en EP&O.',
  },
  {
    status: 4,
    text: 'Tu orden ha sido cancelada.'
  },
  {
    status: 5,
    text: 'Tu orden ha sido rechazada.'
  },
]


const adminStatusLogs = [
  {
    status: 1,
    text: 'La orden del cliente ha sido aceptada. El proveedor debe asignar una fecha de entrega.',
  },
  {
    status: 2,
    text: 'Porfavor entrega la orden con sus productos al cliente.',
  },
  {
    status: 3,
    text: 'La orden ha sido finalizada y entregada.',
  },
  {
    status: 4,
    text: 'La orden ha sido cancelada.',
  },
  {
    status: 5,
    text: 'La orden ha sido rechazada.',
  },
]


const supplierStatusLogs = [
  {
    status: 1,
    text: 'Un cliente ha solicitado un producto. Porfavor da una fecha de entrega.',
  },
  {
    status: 2,
    text: 'La orden se encuentra en camino.',
  },
  {
    status: 3, 
    text: 'La orden ha sido entregada.',
  },
  {
    status: 4, 
    text: 'La orden ha sido cancelada.',
  },
  {
    status: 5, 
    text: 'La orden ha sido rechazada.',
  },
  
]

export const OrderDataStatusLogs = {
  clientStatusLogs,
  adminStatusLogs,
  supplierStatusLogs,
}